export default __webpack_public_path__ + "static/media/66.e8b4d907.jpg";